import React, { useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import TextInputMaskFormik from "../../../../components/UI/TextInput/TextInputMaskFormik";

const DemonstrativoJ1 = ({ formik, sqAcaoFiscal, sqItemOcorrencia, dadosOcorrencia }) => {
  const { calculaIcms, handleMoneyChange, calculaData } = useAcoesDemonstrativo({
    formik,
    sqAcaoFiscal,
  });

  const { setFieldValue } = formik;

  useEffect(() => {
    if (dadosOcorrencia) {
      setFieldValue("sqAcaoFiscal", sqAcaoFiscal);
      setFieldValue("sqItemOcorrencia", sqItemOcorrencia);
      setFieldValue("sqItem", dadosOcorrencia.sqItem);
      setFieldValue("dsItem", dadosOcorrencia.dsItem);
      setFieldValue("txReferencia", dadosOcorrencia.txReferencia);
      setFieldValue("dtVencimento", dadosOcorrencia.dtVencimento);
      setFieldValue("vlDeclarado", dadosOcorrencia.vlDeclarado);
      setFieldValue("vlApurado", dadosOcorrencia.vlApurado);
      setFieldValue("vlIcmsRecolhido", dadosOcorrencia.vlIcmsRecolhido);
      setFieldValue("vlIcms", dadosOcorrencia.vlIcms);
      setFieldValue("tipoDetalhamento", dadosOcorrencia.tipoDetalhamento);
    }
  }, [setFieldValue, dadosOcorrencia, sqAcaoFiscal, sqItemOcorrencia]);

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={12}>
          <span>Descrição:</span>
          <HtmlEditor formik={formik} field="dsItem" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Referência:</Form.Label>
          <TextInputMaskFormik
            formik={formik}
            field="txReferencia"
            placeholder="mm/aaaa"
            mask="99/9999"
            evento={calculaData}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data de Vencimento:</Form.Label>

          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS Declarado (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlDeclarado"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS Apurado (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlApurado"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS Recolhido (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcmsRecolhido"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            evento={calculaIcms}
          />
        </Form.Group>

        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>
            <strong>ICMS a Recolher (R$):</strong>
          </Form.Label>
          <TextInputMoneyFormik formik={formik} field="vlIcms" type="number" onChange={handleMoneyChange} disable />
        </Form.Group>
      </Row>
    </>
  );
};

export default DemonstrativoJ1;
